const _excluded = ["className", "children", "disabled", "size", "skin", "noPadding", "cursorDefault", "intent", "tooltip", "bordered", "preferIntentTooltip"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import { ConditionalWrapper } from "../ConditionalWrapper";
import { useIntentBehavior } from "../IntentBehavior";
import { Tooltip } from "../Tooltip";
import styles from "./IconButton.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const IconButton = /*#__PURE__*/React.forwardRef(function IconButton(props, ref) {
  const {
      className,
      children,
      disabled,
      size = 'medium',
      skin = 'standard',
      noPadding,
      cursorDefault,
      intent,
      tooltip,
      bordered,
      preferIntentTooltip
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const testid = props['data-testid'];
  const {
    getDisabled,
    getTooltip
  } = useIntentBehavior();
  const disabledFromIntent = intent ? getDisabled(intent) : false;
  const tooltipFromIntent = intent ? getTooltip(intent) : null;
  const hasTooltip = !!(tooltip !== null && tooltip !== void 0 && tooltip.title) || !!tooltipFromIntent;
  return /*#__PURE__*/_jsx(ConditionalWrapper, {
    condition: hasTooltip,
    wrapper: children => /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, preferIntentTooltip && tooltipFromIntent ? {
      placement: 'top',
      title: tooltipFromIntent
    } : tooltip || {
      placement: 'top',
      title: tooltipFromIntent
    }), {}, {
      children: /*#__PURE__*/_jsx("div", {
        className: cn(styles.wrapper, className),
        "data-testid": testid && "".concat(testid, "-wrapper"),
        children: children
      })
    })),
    children: /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
      ref: ref,
      disabled: disabledFromIntent || disabled,
      className: cn(styles.root, styles["".concat(skin, "Skin")], styles["".concat(size, "Size")], {
        [styles.noPadding]: noPadding,
        [styles.cursorDefault]: cursorDefault,
        [styles.bordered]: bordered
      }, !hasTooltip && className)
    }, rest), {}, {
      children: children
    }))
  });
});